module.exports = __webpack_public_path__ + "static/media/deal.481217aa.png";